'use client';

import SignOut from '@/lib/frontend/store/actionCreators/SignOut';
import { selectSessionUser } from '@/lib/frontend/store/helpers';
import { useAppSelector, useAppStore } from '@/lib/frontend/store/hooks';
import React, { Fragment } from 'react';

export const FooterSignOut = () => {
  const user = useAppSelector(selectSessionUser);
  const store = useAppStore();

  return (
    <Fragment>
      {user && (
        <button onClick={() => SignOut(store)}>
          <a>Sign Out</a>
        </button>
      )}
    </Fragment>
  );
};
